import {ability_to_characterSheet, CharacterType, Mana} from '../redux/slices/character/characterType';
import {store} from '../redux/store';

//Danke Falk
export const calculateThrowBonus = (value: number) => {
    return Math.floor((value - 10) / 2);
}

/** Gibt das summierte Mana eines Charakters aus */
export const getMaxManaAmount = (): number => {
    const state = store.getState();
    let amount = 0;
    for (const charClassEntry of state.character.character_to_class) {
        for (const classManaEntry of charClassEntry.Class.Mana) {
            if (classManaEntry.manaLevel === charClassEntry.level) {
                amount = amount + classManaEntry.manaAmount;
                break;
            }
        }

        if (charClassEntry.Subclass) {
            for (const subclassManaEntry of charClassEntry.Subclass.Mana) {
                if (subclassManaEntry.manaLevel === charClassEntry.level) {
                    amount = amount + subclassManaEntry.manaAmount;
                    break;
                }
            }
        }
    }

    return amount;
}

/** Gibt das höchste Spelllevel eines Charakters aus */
export const getMaxSpellAmount4Character = () => {
    const state = store.getState();
    let spellAmount = 0;
    for (const charClassEntry of state.character.character_to_class) {
        let value = 0;
        switch (charClassEntry.Class.className) {
            case 'Druide': {
                const wisdomBonus = state.character.CharacterSheet.ability_to_characterSheet.find((ability: ability_to_characterSheet) => ability.Ability.abilityName === 'Weisheit');
                value = calculateThrowBonus(wisdomBonus? wisdomBonus.value : 10)! + charClassEntry.level;
                break;
            }
            case 'Paladin': {
                const charismaBonus = state.character.CharacterSheet.ability_to_characterSheet.find((ability: ability_to_characterSheet) => ability.Ability.abilityName === 'Charisma');
                const bonus = Math.floor(charClassEntry.level/2)
                value = calculateThrowBonus(charismaBonus? charismaBonus.value : 10)! + bonus;
                break;
            }
            case 'Magier': {
                const intBonus = state.character.CharacterSheet.ability_to_characterSheet.find((ability: ability_to_characterSheet) => ability.Ability.abilityName === 'Intelligenz')
                value = calculateThrowBonus(intBonus? intBonus.value : 10)! + charClassEntry.level;
                break;
            }
            case 'Artifizierer': {
                const intBonus = state.character.CharacterSheet.ability_to_characterSheet.find((ability: ability_to_characterSheet) => ability.Ability.abilityName === 'Intelligenz');
                const levelBonus = Math.ceil(charClassEntry.level / 2);
                value = calculateThrowBonus(intBonus? intBonus.value : 10)! + levelBonus;
                break;
            }
            default: {
                for (const classManaEntry of charClassEntry.Class.Mana) {
                    if (classManaEntry.manaLevel === charClassEntry.level) {
                        value = classManaEntry.manaMaxSpells
                        break;
                    }
                }

                if (charClassEntry.Subclass) {
                    for (const subclassManaEntry of charClassEntry.Subclass.Mana) {
                        if (subclassManaEntry.manaLevel === charClassEntry.level) {
                            value = subclassManaEntry.manaMaxSpells
                            break;
                        }
                    }
                }
            }
        }

        spellAmount = spellAmount + value;
    }

    return spellAmount;
}

/** Gibt die aufsummierte Anzahl an Spells aus */
export const getMaxSpellLevel4Character = () => {
    const state = store.getState();
    let isSubclass = false;
    let highestLevelString = ""
    for (const charClassEntry of state.character.character_to_class) {
        let value = 0;
        for (const classManaEntry of charClassEntry.Class.Mana) {
            if (classManaEntry.manaLevel === charClassEntry.level) {
                value = classManaEntry.manaMaxSpellLevel;
                break;
            }
        }

        if (charClassEntry.Subclass) {
            for (const subclassManaEntry of charClassEntry.Subclass.Mana) {
                if (subclassManaEntry.manaLevel === charClassEntry.level) {
                    value = subclassManaEntry.manaMaxSpellLevel;
                    isSubclass = true;
                    break;
                }
            }
        }

        highestLevelString = highestLevelString + (highestLevelString === "" ? `${isSubclass ? charClassEntry.Subclass.subclassName : charClassEntry.Class.className}: ${value}` : ` | ${charClassEntry.Class.className}: ${value}`)
    }

    return highestLevelString;
}

/** Gibt die aufsummierte Menge an Cantrips aus */
export const getCantripsForCharacter = () => {
    const state = store.getState();
    let cantripAmount = 0;
    for (const charClassEntry of state.character.character_to_class) {
        for (const classManaEntry of charClassEntry.Class.Mana) {
            if (classManaEntry.manaLevel === charClassEntry.level) {
                cantripAmount = cantripAmount + classManaEntry.manaCantrips;
                break;
            }
        }

        if (charClassEntry.Subclass) {
            for (const subclassManaEntry of charClassEntry.Subclass.Mana) {
                if (subclassManaEntry.manaLevel === charClassEntry.level) {
                    cantripAmount = cantripAmount + subclassManaEntry.manaCantrips;
                    break;
                }
            }
        }
    }

    return cantripAmount;
}

export const calculateProficiency = (proficiency: number, character: CharacterType) => {
    let value: number = 0
    if (proficiency > 0) {
        switch (character.characterLevel) {
            case 1:
            case 2:
            case 3:
            case 4:
                value = 2;
                break;
            case 5:
            case 6:
            case 7:
            case 8:
                value = 3;
                break;
            case 9:
            case 10:
            case 11:
            case 12:
            case 13:
            case 14:
                value = 4;
                break;
            case 15:
            case 16:
            case 17:
            case 18:
            case 19:
            case 20:
                value = 5;
                break;
            default:
                return 6
        }
        return proficiency === 1 ? value : value * 2
    }
    return 0;
}
